(function (root, factory) {
  var api = factory();
  if (typeof module !== "undefined" && module.exports) {
    module.exports = api;
  }
  if (root.document) api.start();
})(typeof window !== "undefined" ? window : this, function () {
  "use strict";

  var WEEKDAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  var MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  var TAG_NAMES = ["b2b", "PG", "OB:38:00", "OB:24:00", "OB:14:00", "og"];
  var RULES = {
    b2b: { label: "Preorder (2–3 days)", before3: 2, after3: 3 },
    PG: { label: "1-day preorder", before3: 1, after3: 2 },
    "OB:38:00": { label: "1-day preorder", before3: 1, after3: 2 },
    "OB:24:00": { label: "1-day preorder", always: 1 },
    "OB:14:00": { label: "Same-day", before3: 0, after3: 1 },
    og: { label: "Frozen gelato", og: true },
  };

  function singaporeNow(date) {
    var parts = new Intl.DateTimeFormat("en-US", {
      timeZone: "Asia/Singapore",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      weekday: "short",
      hourCycle: "h23",
    }).formatToParts(date);
    function part(type) {
      for (var i = 0; i < parts.length; i++) {
        if (parts[i].type === type) return parts[i].value;
      }
      return "";
    }
    var hour = parseInt(part("hour"), 10);
    if (hour === 24) hour = 0;
    var weekdayIndex = WEEKDAYS.indexOf(part("weekday"));
    return {
      y: parseInt(part("year"), 10),
      m: parseInt(part("month"), 10),
      d: parseInt(part("day"), 10),
      weekday: weekdayIndex,
      minutes: hour * 60 + parseInt(part("minute"), 10),
    };
  }

  function addDays(date, days) {
    var next = new Date(Date.UTC(date.y, date.m - 1, date.d + days));
    return {
      y: next.getUTCFullYear(),
      m: next.getUTCMonth() + 1,
      d: next.getUTCDate(),
      weekday: next.getUTCDay(),
    };
  }

  function dayDiff(from, to) {
    var start = Date.UTC(from.y, from.m - 1, from.d);
    var end = Date.UTC(to.y, to.m - 1, to.d);
    return Math.round((end - start) / 86400000);
  }

  function hasTag(tags, name) {
    var want = name.toLowerCase();
    for (var i = 0; i < tags.length; i++) {
      if (String(tags[i]).trim().toLowerCase() === want) return true;
    }
    return false;
  }

  function snapPg(date) {
    var allowed = { 0: true, 2: true, 4: true };
    var cursor = date;
    for (var i = 0; i < 7; i++) {
      if (allowed[cursor.weekday]) return cursor;
      cursor = addDays(cursor, 1);
    }
    return date;
  }

  function leadFor(tag, method, minutes) {
    var rule = RULES[tag];
    if (rule.always != null) return rule.always;
    if (rule.og) {
      if (method === "pickup") return minutes >= 18 * 60 ? 1 : 0;
      return minutes >= 15 * 60 ? 1 : 0;
    }
    return minutes >= 15 * 60 ? rule.after3 : rule.before3;
  }

  function earliestForTag(tag, method, now) {
    var date = addDays(now, leadFor(tag, method, now.minutes));
    if (tag === "PG") return snapPg(date);
    return date;
  }

  function strictest(tags, method, now, skipTag) {
    var best = null;
    for (var i = 0; i < TAG_NAMES.length; i++) {
      var tag = TAG_NAMES[i];
      if (tag === skipTag || !hasTag(tags, tag)) continue;
      var date = earliestForTag(tag, method, now);
      if (!best || dayDiff(best.date, date) > 0) best = { tag: tag, date: date };
    }
    return best;
  }

  function formatDate(date) {
    return WEEKDAYS[date.weekday] + " " + date.d + " " + MONTHS[date.m - 1];
  }

  function orderCutoff(tag, method, now) {
    if (tag === "OB:24:00") return "";
    if (tag === "og" && method === "pickup") {
      return now.minutes < 18 * 60 ? "6pm" : "";
    }
    if (tag === "og" || tag === "OB:14:00" || tag === "OB:38:00" || tag === "PG" || tag === "b2b") {
      return now.minutes < 15 * 60 ? "3pm" : "";
    }
    return "";
  }

  function readyLine(tag, method, date, now) {
    if (tag === "og" && method !== "pickup" && method !== "delivery") {
      if (now.minutes < 15 * 60) {
        return "Ready today if ordered by 3pm for delivery, or 6pm for pickup";
      }
      if (now.minutes < 18 * 60) {
        return "Ready by tomorrow for delivery, or today if ordered by 6pm for pickup";
      }
      return "Ready by tomorrow";
    }
    var diff = dayDiff(now, date);
    var when = diff <= 0 ? "Ready today" : diff === 1 ? "Ready by tomorrow" : "Ready by " + formatDate(date);
    var cutoff = orderCutoff(tag, method, now);
    return cutoff ? when + " if ordered by " + cutoff : when;
  }

  var MONTH_INDEX = {
    jan: 1, january: 1, feb: 2, february: 2, mar: 3, march: 3, apr: 4, april: 4,
    may: 5, jun: 6, june: 6, jul: 7, july: 7, aug: 8, august: 8,
    sep: 9, sept: 9, september: 9, oct: 10, october: 10, nov: 11, november: 11,
    dec: 12, december: 12,
  };

  function dateParts(y, m, d) {
    if (m < 1 || m > 12 || d < 1 || d > 31) return null;
    var utc = new Date(Date.UTC(y, m - 1, d));
    if (utc.getUTCFullYear() !== y || utc.getUTCMonth() !== m - 1 || utc.getUTCDate() !== d) return null;
    return { y: y, m: m, d: d, weekday: utc.getUTCDay() };
  }

  function parseDisplayDate(value) {
    var s = String(value || "").replace(/,/g, " ").replace(/\s+/g, " ").trim();
    if (!s || /choose|select a date/i.test(s)) return null;
    var iso = s.match(/^(\d{4})[\/\-](\d{1,2})[\/\-](\d{1,2})$/);
    if (iso) return dateParts(+iso[1], +iso[2], +iso[3]);
    var dmy = s.match(/^(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{4})$/);
    if (dmy) return dateParts(+dmy[3], +dmy[2], +dmy[1]);
    var dayFirst = s.match(/(\d{1,2})\s+([A-Za-z]+)\s+(\d{4})/);
    if (dayFirst && MONTH_INDEX[dayFirst[2].toLowerCase()]) {
      return dateParts(+dayFirst[3], MONTH_INDEX[dayFirst[2].toLowerCase()], +dayFirst[1]);
    }
    var monthFirst = s.match(/([A-Za-z]+)\s+(\d{1,2})\s+(\d{4})/);
    if (monthFirst && MONTH_INDEX[monthFirst[1].toLowerCase()]) {
      return dateParts(+monthFirst[3], MONTH_INDEX[monthFirst[1].toLowerCase()], +monthFirst[2]);
    }
    return null;
  }

  function topLine(date, method, chosen) {
    var when = formatDate(date);
    var verb = chosen ? "will be" : "can be";
    var join = chosen ? " on " : " from ";
    if (method === "pickup") return "Your cakes " + verb + " ready for pickup together" + join + when;
    if (method === "delivery") return "Your cakes " + verb + " delivered together" + join + when;
    return "Your cakes " + verb + " ready together" + join + when;
  }

  function isRestricted(tags) {
    return hasTag(tags, "b2b") || hasTag(tags, "PG") || hasTag(tags, "OB:38:00") || hasTag(tags, "OB:24:00");
  }

  function planCart(tagLists, method, now, chosenDate) {
    var items = [];
    var cartDate = null;
    var anyPg = false;
    var restricted = false;
    for (var i = 0; i < tagLists.length; i++) {
      var tags = tagLists[i] || [];
      if (hasTag(tags, "PG")) anyPg = true;
      if (isRestricted(tags)) restricted = true;
      var picked = strictest(tags, method, now);
      if (!picked) {
        items.push(null);
        continue;
      }
      var labelPick = strictest(tags, method, now, "og");
      var labelTag = labelPick ? labelPick.tag : "";
      items.push({
        label: labelTag ? RULES[labelTag].label : "",
        kind: labelTag === "OB:14:00" ? "same-day" : labelTag === "b2b" ? "long" : "preorder",
        frozen: hasTag(tags, "og"),
        ready: readyLine(picked.tag, method, picked.date, now),
      });
      if (!cartDate || dayDiff(cartDate, picked.date) > 0) cartDate = picked.date;
    }
    if (cartDate && anyPg) cartDate = snapPg(cartDate);
    var shown = chosenDate || cartDate;
    return {
      title: shown ? topLine(shown, method, !!chosenDate) : "",
      description: "",
      restricted: restricted,
      items: items,
    };
  }

  var methodOverride = "";

  function textOf(element) {
    return String((element && element.textContent) || "").toLowerCase();
  }

  function methodFromText(text) {
    var pickup = text.indexOf("pickup") !== -1;
    var deliver = text.indexOf("deliver") !== -1;
    if (pickup && !deliver) return "pickup";
    if (deliver && !pickup) return "delivery";
    return "";
  }

  function rememberMethod(method) {
    if (method === "pickup" || method === "delivery") methodOverride = method;
  }

  function methodOfNode(node) {
    if (!node) return "";
    var name = node.querySelector ? node.querySelector(".checkoutMethodName") : null;
    var label = name ? textOf(name) : textOf(node);
    var fromLabel = methodFromText(label);
    if (fromLabel) return fromLabel;
    var hint = [node.id, node.getAttribute && node.getAttribute("data-method"), node.getAttribute && node.getAttribute("value")]
      .join(" ")
      .toLowerCase();
    if (hint.indexOf("pickup") !== -1) return "pickup";
    if (hint.indexOf("deliver") !== -1) return "delivery";
    return "";
  }

  function activeCheckoutMethod() {
    var root = document.getElementById("storePickupApp");
    if (!root) return "";
    var active = root.querySelectorAll(".checkoutMethod.active");
    for (var i = 0; i < active.length; i++) {
      var method = methodOfNode(active[i]);
      if (method) return method;
    }
    var checked = root.querySelector("input[type='radio']:checked");
    return checked ? methodOfNode(checked) : "";
  }

  function looksLikeDateControl(element) {
    var node = element;
    for (var i = 0; i < 4 && node; i++) {
      var hint = [
        node.className,
        node.id,
        node.getAttribute && node.getAttribute("placeholder"),
        node.getAttribute && node.getAttribute("aria-label"),
      ].join(" ").toLowerCase();
      if (hint.indexOf("date") !== -1 || hint.indexOf("calendar") !== -1) return true;
      node = node.parentElement;
    }
    return false;
  }

  function attributeDate(method) {
    var attrs = (window.ZapietCart && window.ZapietCart.attributes) || {};
    var raw = "";
    if (method === "pickup") raw = attrs["Pickup-Date"] || attrs["Pickup-Day"] || "";
    else if (method === "delivery") raw = attrs["Delivery-Date"] || attrs["Delivery-Day"] || "";
    else raw = attrs["Delivery-Date"] || attrs["Pickup-Date"] || "";
    return parseDisplayDate(raw);
  }

  function chosenDate(method) {
    var root = document.getElementById("storePickupApp");
    if (!root) return attributeDate(method);

    var inputs = root.querySelectorAll("input");
    var sawDateField = false;
    var fallback = null;
    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      if (String(input.type || "").toLowerCase() === "hidden") continue;
      var parsed = parseDisplayDate(input.value);
      if (looksLikeDateControl(input)) {
        sawDateField = true;
        if (parsed) return parsed;
      } else if (parsed && !fallback) {
        fallback = parsed;
      }
    }
    if (sawDateField) return null;
    if (fallback) return fallback;

    var blocks = root.querySelectorAll("div, span, button");
    for (var j = 0; j < blocks.length; j++) {
      var text = String(blocks[j].textContent || "").replace(/\s+/g, " ").trim();
      if (!text || text.length > 40 || blocks[j].querySelector("input, div, span, button")) continue;
      var parsedText = parseDisplayDate(text);
      if (parsedText) return parsedText;
    }

    return attributeDate(method);
  }

  function selectedMethod() {
    var fromDom = activeCheckoutMethod();
    if (fromDom) return fromDom;

    if (methodOverride === "pickup" || methodOverride === "delivery") return methodOverride;

    if (window.Zapiet && typeof window.Zapiet.getSelectedCheckoutMethod === "function") {
      try {
        var current = String(window.Zapiet.getSelectedCheckoutMethod() || "").toLowerCase();
        if (current === "pickup" || current === "delivery") return current;
      } catch (err) {}
    }

    var attrs = (window.ZapietCart && window.ZapietCart.attributes) || {};
    var saved = String(attrs["Checkout-Method"] || attrs["checkout-method"] || "").toLowerCase();
    if (saved === "pickup" || saved === "delivery") return saved;
    return "";
  }

  function render() {
    var root = document.querySelector(".cart__template [data-cart-ready-root]");
    if (!root) return;
    var rows = root.querySelectorAll("[data-cart-item]");
    var tagLists = [];
    for (var i = 0; i < rows.length; i++) {
      var raw = rows[i].getAttribute("data-product-tags") || "";
      tagLists.push(raw ? raw.split("||") : []);
    }
    var method = selectedMethod();
    var plan = planCart(tagLists, method, singaporeNow(new Date()), chosenDate(method));
    var note = document.querySelector(".cart__template [data-cart-preorder-note]");
    if (note) note.hidden = !plan.restricted;
    var bar = document.querySelector(".cart__template [data-cart-ready]");
    var title = bar && bar.querySelector("[data-cart-ready-title]");
    var description = bar && bar.querySelector("[data-cart-ready-description]");
    if (bar && title) {
      title.textContent = plan.title;
      if (description) {
        description.textContent = plan.description || "";
        description.hidden = !plan.description;
      }
      bar.hidden = !plan.title;
    }
    for (var j = 0; j < rows.length; j++) {
      var notice = rows[j].querySelector("[data-cart-item-notice]");
      if (!notice) continue;
      var item = plan.items[j];
      if (!item) {
        notice.hidden = true;
        continue;
      }
      var label = notice.querySelector("[data-cart-item-label]");
      if (label) {
        label.textContent = item.label || "";
        label.className = "lacher-cart-item-notice__label lacher-cart-item-notice__label--" + item.kind;
        label.hidden = !item.label;
      }
      var frozen = notice.querySelector("[data-cart-item-frozen]");
      if (frozen) frozen.hidden = !item.frozen;
      notice.hidden = !item.label && !item.frozen;
    }
  }

  function watchMethod(root) {
    if (!root || root.__lacherReadyWatch) return;
    root.__lacherReadyWatch = true;
    root.addEventListener(
      "click",
      function (event) {
        var node = event.target;
        var methodNode = node && node.closest ? node.closest(".checkoutMethod") : null;
        var method = methodOfNode(methodNode);
        if (!method) {
          while (node && node !== root) {
            method = methodFromText(textOf(node));
            if (method) break;
            node = node.parentElement;
          }
        }
        if (!method) return;
        rememberMethod(method);
        render();
      },
      true
    );
    root.addEventListener("change", render, true);
    root.addEventListener("input", render, true);
    new MutationObserver(render).observe(root, {
      attributes: true,
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  function start() {
    function boot() {
      render();
      watchMethod(document.getElementById("storePickupApp"));
      if (window.ZapietEvent && typeof window.ZapietEvent.listen === "function" && !window.__lacherCartReadyBound) {
        window.__lacherCartReadyBound = true;
        window.ZapietEvent.listen("widget_loaded", function () {
          watchMethod(document.getElementById("storePickupApp"));
          render();
        });
        window.ZapietEvent.listen("selected_method", function (checkoutMethod) {
          rememberMethod(String(checkoutMethod || "").toLowerCase());
          render();
        });
        window.ZapietEvent.listen("locationSelected", function (payload) {
          var method = payload && payload.method ? String(payload.method).toLowerCase() : "";
          rememberMethod(method);
          render();
        });
        window.ZapietEvent.listen("checkoutEnabled", function (payload) {
          var method = payload && payload.method ? String(payload.method).toLowerCase() : "";
          rememberMethod(method);
          render();
        });
      }
    }

    var lineItems = document.querySelector(".cart__template [data-line-items]");
    if (lineItems) {
      new MutationObserver(boot).observe(lineItems, { childList: true });
    }
    document.addEventListener("theme:cart:change", boot);
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", boot);
    } else {
      boot();
    }

    var tries = 0;
    var timer = setInterval(function () {
      boot();
      tries += 1;
      if (tries >= 20) clearInterval(timer);
    }, 500);
  }

  return {
    planCart: planCart,
    parseDisplayDate: parseDisplayDate,
    singaporeNow: singaporeNow,
    start: start,
  };
});
